import {useState} from 'react';
import {useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {translations} from '../../../../../../i18n/translations';
import {Box, Stack, SxProps} from '@mui/material';
import GenericHeader from '../../../../../../components/generic-header/generic-header';
import {EntityStatisticsDashboard} from '../../../../../../components/entity-statistics-dashboard/entity-statistics-dashboard';
import {useAuth} from '../../../../../../contexts/auth/context';
import {LocalStorageKey, ScreenPaths} from '../../../../../../enums';
import {Moment} from 'moment';
import {
  calcEndDateByRange,
  calcStartDateByRange,
  DateRangeType,
} from '../../../../../../components/date-range-input/date-range-utils';
import {DateRangeInput} from '../../../../../../components/date-range-input/date-range-input';

export default function StatisticsProfessionalCaregiverOfficeScreen() {
  const authContext = useAuth();
  const [startDate, setStartDate] = useState(getInitialStartDate);
  const [endDate, setEndDate] = useState(getInitialEndDate);

  let {entityId}: {entityId?: string} = useParams();

  const {t} = useTranslation();

  const boxWrapperSx: SxProps = {
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    width: '100%',
  };

  const basePath = `/office${ScreenPaths.Office_ProfessionalCaregiver}/${authContext.state.session?.selectedAffiliation?.entity.id}${ScreenPaths.ProfessionalCaregiver_Dashboard}`;

  return (
    <Box sx={boxWrapperSx}>
      <GenericHeader
        titleCrumbs={[
          {label: t(translations.dashboard_side_menu.dashboard), link: basePath},
          {
            label: t(translations.dashboard_side_menu.statistics),
            link: `${basePath}${ScreenPaths.ProfessionalCaregiver_Statistics}`,
          },
          {
            label: t(translations.dashboard_side_menu.general_statistics),
            link: `${basePath}${ScreenPaths.ProfessionalCaregiver_Statistics}`,
          },
        ]}
        isLoading={false}
        leftColumn={<></>}
        rightColumn={
          <Stack direction="row" justifyContent="flex-end" alignItems="center">
            <DateRangeInput
              startDate={startDate}
              endDate={endDate}
              onChange={(startDate, endDate, range) => {
                setStartDate(startDate);
                setEndDate(endDate);
                if (range !== 'custom')
                  localStorage.setItem(LocalStorageKey.EntityGeneralChartsRange, range);
              }}
            />
          </Stack>
        }
      />
      <EntityStatisticsDashboard
        startDate={startDate}
        endDate={endDate}
        entityId={entityId || ''}
        notShowRefreshButton
      />
    </Box>
  );
}

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------

function getInitialStartDate(): Moment {
  // Get stored range
  const storedRange = localStorage.getItem(
    LocalStorageKey.EntityGeneralChartsRange
  ) as DateRangeType | null;

  // Get start date by range
  return calcStartDateByRange(storedRange ?? '7d');
}

function getInitialEndDate(): Moment {
  // Get stored range
  const storedRange = localStorage.getItem(
    LocalStorageKey.EntityGeneralChartsRange
  ) as DateRangeType | null;

  // Get start date by range
  return calcEndDateByRange(storedRange ?? '7d');
}
